export const getSymbol = (currency) => {
  const symbol = new Intl.NumberFormat('en-US', {
    currency,
    currencyDisplay: 'narrowSymbol',
    style: 'currency'
  }).formatToParts().find((part) => part.type === 'currency');
  return symbol && symbol.value;
};
